import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import {
  getSubcategoryListQuery,
  getListOfSubcategoriesforFolderViewQuery,
} from "../../../services/graphql/queries/category-management";
import DisplayErrors from "../../Common/DisplayErrors";

class SubcategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: [],
      subcategories: [],
    };
  }

  getListOfSubcategory() {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getListOfSubcategoriesforFolderViewQuery,
        variables: {
          referenceId: this.props.referenceId,
          categoryId: this.props.category,
          subcategoryLevel: this.props.subcategoryLevel + 1,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var subcategories = result.data.getListOfSubcategoriesforFolderView;

        this.initialState = {
          subcategories: subcategories,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        this.setState({ loading: false, error: error.message });
      });
  }

  componentDidMount() {
    this.getListOfSubcategory();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.category !== this.props.category ||
      prevProps.referenceId !== this.props.referenceId ||
      prevProps.subcategoryLevel !== this.props.subcategoryLevel
    ) {
      this.getListOfSubcategory();
    }
  }

  render() {
    const { loading, errors, subcategories } = this.state;
    return (
      <div className="p-t-0" id="showlistDiv">
        <div className="row align-items-center">
          <div className="col-md-12">
            <h1 className="heading m-b-0">
              {this.props.subcatName} - Folder List
            </h1>
            <div
              className="row"
              style={{
                display: errors.length === 0 ? "none" : "block",
              }}
            >
              <div className="col-md-6">
                <div className="alert alert-success" role="alert">
                  <div className="row">
                    <span className="danger-link">
                      <DisplayErrors errors={errors} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive" style={{ maxHeight: "52vh" }}>
          <table className="table table-style-1 ">
            <thead>
              <tr>
                <th scope="col" width={400}>
                  ID
                </th>
                <th scope="col" width={400}>
                  FOLDER / SUB - FOLDER NAME
                </th>
                <th scope="col" width={400}>
                  DESCRIPTION
                </th>
              </tr>
            </thead>
            <tbody>
              {subcategories.length
                ? subcategories.map((subcategory, index) => {
                    return (
                      <tr key={index}>
                        <td>{subcategory.id}</td>
                        <td>
                          {subcategory && subcategory.name
                            ? subcategory.name
                            : ""}
                        </td>
                        <td>{subcategory.description}</td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
          {!subcategories.length && !loading ? (
            <div style={{ textAlign: "center" }}>No Data</div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(withApollo(SubcategoryList)));
